import {join} from "lodash";
import {mustBeArray} from "./utils";

export const BASE_URL = '';
let IdentityServerUrl = () => {
  // if local identity http://localhost:8081/identityserver/core
  return process.env.NODE_ENV == 'development' ? 
  'https://apps-dev.coastalcookingoils.com.au/identityserver/core'
  : `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/identityserver/core`;
};

let FullBaseUrl = () => {
  return `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}${BASE_URL}`;
};

export const BASE_START_LOCATION_ID = 4912;
export const BASE_END_LOCATION_ID = 4906;
export const LOCATION_TYPE_BASE_CODE = "B";
export const LOCATION_TYPE_DROPOFF_CODE = "D";

export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';
export const ROLE_NewUser = 'NewUser';
export const ROLE_Driver = 'Driver';
export const ROLE_ClientUser = 'ClientUser';
export const ROLE_LocationUser = 'LocationUser';
export const ROLE_SuperUser = 'SuperUser';
export const ROLE_OfficeUser = 'OfficeAdmin';
export const ROLE_Admin = 'Administrator';
export const ROLE_SalesManager = 'SalesManager';
export const ROLE_BDM = 'BDM';

export const URL_NewUser = `${BASE_URL}/newuser/`;
export const URL_NewClientLocation = `${BASE_URL}/manage/new-client-location`;
export const URL_Clients = `${BASE_URL}/manage/clients/`;
export const URL_Locations = `${BASE_URL}/manage/locations/`;

export const EMAIL_REG_EX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const KG_L_CONVERSION = 1.087;

export const COMMUNICATION_TYPES_WITH_MARKETING_OPTIONS = [
  "Sms Phone", "Mobile Phone", "Work Email", "Other Email"
];

export const COMMUNICATION_TYPES_WITH_RUN_COMMUNICATION_OPTIONS = [
  "Sms Phone", "Mobile Phone"
];

export const COMMUNICATION_NOTIFICATION_OPTIONS = [
  {id: 1, name: "Run Communication"}
];

let IsCordovaApp = () => {
  //return true;
  return window.isCordovaApp;
  //return document.URL.indexOf('http://') === -1 && document.URL.indexOf('https://') === -1;
};

export { IdentityServerUrl, FullBaseUrl, IsCordovaApp };

export const SHORT_DATE_FORMAT = 'YYYY-MM-DD';
export const LONG_DATE_FORMAT = "YYYY-MM-DD h:mm:ss a";

export const TANK_ACTION_TYPE_PICKUP = 1;
export const TANK_ACTION_TYPE_DROPOFF = 2;

export function IsInRole(account, role) {
  return account && account.user && account.user.hasRole(role);
}

/**
 * 
 * @param {*} account 
 * @param {string[]} roles 
 * @returns 
 */
export function allowUserWithRoles(account, roles = []){
  if(!Array.isArray(roles)) return false;
  return roles.map(role => IsInRole(account, role)).includes(true);
}

export function IsCurrentUser(account, user) {
  return account && account.user && ((user.userId && account.user.id == user.userId.replace(/\-/g, '')) || account.user.id == user.id);
}

export const validationCreator = (isValid = true, message = '')=> {
  return {isValid, message};
};

export function IsStringValid(val, reg){
  let isValid = reg ? (val === null || val === undefined || val === '' || (val.hasOwnProperty('trim') && val.trim() == '' )
    || !val.toString().match(reg)) : (val === null || val === undefined || val === '' || (val.hasOwnProperty('trim') && val.trim() == '' ));
  return !isValid;
}

export function HandleFieldChange(e, stateKey, thisRef, setStateCallBack = null) {
  let state = {};
  state[stateKey] = {...thisRef.state[stateKey]};

  if (e.target.type === "checkbox") {
    state[stateKey][e.target.name] = e.target.checked;
  } else {
    state[stateKey][e.target.name] = e.target.value;
  }

  thisRef.setState(state, setStateCallBack);
}

export function ValidateStateKeys(stateKeys = [], thisRef, validationRules) {
  let messages = {};
  let isValid = true;

  let runValidator = (rules, stateItem, stateKey) => {
    for (let propName in rules) {

      let rule = rules[propName];
      let val = stateItem[propName];

      let valResult = rule.validator(val, thisRef.state, thisRef.props);
      if (!valResult.isValid) {
        messages[stateKey][propName] = valResult.message;
        isValid = false;
      }
    }
  };

  for (let i = 0; i < stateKeys.length; i++) {
    if(!messages[stateKeys[i]]){
      messages[stateKeys[i]] = {};
    }
    runValidator(validationRules[stateKeys[i]], thisRef.state[stateKeys[i]], stateKeys[i]);
  }

  thisRef.setState({validationMessages: messages, isValid,});

  return isValid;
}

export const Aux = props => props.children;

export function IsNullOrUndefined(input){
  return input === null || input === undefined;
}
export function isNullEmptyOrWhitespace(v) {
  return v === null || v === undefined || v == '' || v.toString().trim() == '';
}

export function SpaceString(items, delimiter = ' ') {
  let filtered = items.filter(x => !isNullEmptyOrWhitespace(x));
  return filtered.length === 0 ? null :
      join(filtered, delimiter);
}

export function TextInputParseInt(input) {
  let val = parseInt(input);
  if (!(val >= 0)) {
    val = "";
  }
  return val;
}

export const getIsBaseDropOff = (location) => {
  return location.locationTypeUniqueCode === LOCATION_TYPE_BASE_CODE ? 'Base' : 'Drop-off';
};

export function GetUserLocation(userLocation){
  if(IsNullOrUndefined(userLocation)){
    return {latitude: null, longitude: null, hasUserLocation: false};
  }
  
  let latitude = userLocation.coords ? userLocation.coords.latitude : null;
  let longitude = userLocation.coords ? userLocation.coords.longitude : null;
  if(latitude === 0){
    latitude = null;
  }
  if(longitude === 0){
    longitude = null;
  }
  return {latitude, longitude, hasUserLocation: !IsNullOrUndefined(latitude) && !IsNullOrUndefined(longitude)};
}

export const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';
export const DISPLAY_DATE_FORMAT = "DD-MM-YYYY";

// Current used RCTI and invoice status ids
export const READY_FOR_EXPORT_STATUS_ID = 1;
export const EXPORTED_STATUS_ID = 2;
export const ERROR_RCTI_STATUS_ID = 3;

// frozen enum for replacement of individual constants of RCTI and invoice status ids
export const EXPORT_STATUS_IDS = Object.freeze({
  ReadyForExport: 1,
  Exported: 2,
  ErrorRcti: 3,
  Exporting: 4
});

export const INVOICE_EXPORT_STATUS_IDS = Object.freeze({
  ReadyForExport: 1,
  Exporting: 2,
  Exported: 3,
  Error: 4,
});

export const REQUEST_URGENT_COLLECTION_MESSAGE = "Please note, you will be required to submit photos for an urgent request. If your collection is booked, scheduled, completed and we find that there is an insufficient amount of oil, you may be charged an $80 service fee.";
export const DO_YOU_ACCEPT_THESE_TERMS = "Do you accept these terms?";
export const URGENT_COLLECTION_REQUEST_MESSAGE = "Please upload photos and provide any additional information that may be relevant. This will ensure that we dispatch a collection at the soonest possible time.";
export const URGENT_TANK_SWAP_REQUEST_MESSAGE = "Please upload photos and provide any additional information that may be relevant. We will be in touch to confirm a tank swap as soon as we have confirmed.";
export const TANK_SWAP_MESSAGE = "If your tank is in need of maintenance, please use the request tank swap buttton.";
export const MAX_FILE_SIZE = 5000000;

export const CLIENT_REQUEST_APPROVED_ID = 2;
export const CLIENT_REQUEST_REJECTED_ID = 3;
export const CLIENT_REQUEST_PENDING_ID = 1;
export const CLIENT_REQUEST_PENDING_CLIENT_ACTIONS_ID = 4;
export const CLIENT_REQUEST_IN_PROGRESS_CLIENT_ACTIONS_ID = 5;
export const CLIENT_REQUEST_IN_COMPLETE_CLIENT_ACTIONS_ID = 6;

export const TANK_SWAP_REQUEST_ID = 1;
export const URGENT_COLLECTION_REQUEST_ID = 2;
export const AUTO_TANK_SWAP_REQUEST_ID = 3;
export const URGENT_DELIVERY_REQUEST_ID = 4;

// Expired Link Error message
export const EXPIRED_PICKUP_CONFIRMATION_MESSAGE = "Link no longer available, your collection will be scheduled for the next available run in your area";
export const URGENT_RUN_TAKE_PHOTOS_MESSAGE = "This is an urgent run, you will need to take photos of this location";

export const CUSTOMER_TYPES_IDS = Object.freeze({
  CollectionBulk: 1,
  CollectionTin: 2,
  FreshOilBulk: 3,
  FreshOilBib: 4
});

export const TANK_ASSET_TYPES_IDS = Object.freeze({
  CollectionBulk: 1,
  FreshOilBulk: 2,
  FreshOilBib: 3
});

export const TRUCK_TYPES_CODES = Object.freeze({
  CollectionBulk: "B",
  CollectionTin: "T",
  AssetDelivery: "A",
  DeliveryBulk: "BD",
  DeliveryBib: "BIBD"
});

export const CUSTOMER_TYPES_NAMES = Object.freeze({
  Collection: "Collection",
  FreshOil: "Fresh Oil"
});

export function GetIsBulkCustomerType(assignedCustomerTypes){
  // Ids of bulk type oils are fixed
  return [CUSTOMER_TYPES_IDS.CollectionBulk, CUSTOMER_TYPES_IDS.FreshOilBulk].some(id => mustBeArray(assignedCustomerTypes).includes(id));
}

export function GetIsCollectionCustomer(assignedCustomerTypes){
  return [CUSTOMER_TYPES_IDS.CollectionBulk, CUSTOMER_TYPES_IDS.CollectionTin].some(id => mustBeArray(assignedCustomerTypes).includes(id));
}

export function GetIsFreshOilCustomer(assignedCustomerTypes){
  return [CUSTOMER_TYPES_IDS.FreshOilBib, CUSTOMER_TYPES_IDS.FreshOilBulk].some(id => mustBeArray(assignedCustomerTypes).includes(id));
}